import {
  QuestionResponse,
  FreeFormQuestionResponse,
  MultipleChoiceQuestionResponse,
  QuestionReviewResponse,
  VideoUploadQuestionResponse,
  DocumentUploadQuestionResponse,
} from '../../../../firebase/firestore/documents/candidate';

export enum QuestionType {
  YES_NO = 'questionResponses',
  FREE_FORM = 'freeFormQuestionResponses',
  MCQ = 'multipleChoiceQuestionResponses',
  VIDEO_RESPONSE = 'videoUploadQuestionResponses',
  DOCUMENT_UPLOAD = 'documentUploadQuestionResponses',
}
export interface FormDataItem {
  questionId: string;
  questionType: string;
  isAnswerAccepted: boolean;
}
export type QuestionTypeT = typeof QuestionType[keyof typeof QuestionType];
export type QuestionResponseType =
  | QuestionResponse
  | FreeFormQuestionResponse
  | MultipleChoiceQuestionResponse
  | VideoUploadQuestionResponse
  | DocumentUploadQuestionResponse;

export type QuestionOnReviewT = {
  id: string;
  type: QuestionTypeT;
  preferredAnswer?: boolean;
  text?: string;
  isPausable?: boolean;
  answer?: boolean | string;
  answer_hls?: string;
  totalAnswer?: number | 'any';
  reviewed?: boolean;
  skipped?: boolean;
  answers?: MultipleChoiceQuestionResponse['answers'] | DocumentUploadQuestionResponse['answers'];
} & QuestionReviewResponse &
  Partial<
    Pick<
      MultipleChoiceQuestionResponse,
      | 'images'
      | 'isAnsweredCorrectly'
      | 'question'
      | 'preferredAnswers'
      | 'options'
      | 'correctAnswerDeterminationType'
      | 'shouldMatchAtLeast'
      | 'knockout'
    >
  >;
